/* global google */
export default {
  name: 'EmergencyContactMap',
  props: {
    locationName: {
      type: String,
      default: 'Property Location'
    },
    propertyCoordinates: {
      type: Object,
      default: null
    },
    municipality: {
      type: String,
      default: 'City Municipality'
    },
    waterUtility: {
      type: String,
      default: 'Water Utility'
    },
    tariffRegime: {
      type: String,
      default: 'Tariff Information'
    },
    selectedProperty: {
      type: Object,
      default: null
    }
  },
  data() {
    return ({
      map: null,
      mapLoading: false,
      mapError: false,
      searchQuery: '',
      markers: [],
      nearestPlaces: [],
      shoppingCenters: [],
      nearestByType: {},
      infoWindow: null,
      propertyLocation: null,
      radiusCircle: null,
      directionsService: null,
      directionsRenderers: {},
      routeColors: ['#FF0000', '#0000FF', '#00FF00', '#FFFF00', '#FF00FF', '#00FFFF', '#FFA500'],
      showRoutes: {},
      mapTypeId: 'satellite',
      is_hovered: false,
      tilt: 0,
      heading: 0,
      showAllCompetitorCenters: false,
      propertyShoppingCenter: null,
      propertyAnchorTenants: [],
      competitorShoppingCenters: [],
      show_map_overlay: true,

      // Cache Places API responses to reduce repeat requests per property
      places_cache: {},
      places_cache_prefix: 'places_cache_v1',
      places_cache_ttl_ms: 24 * 60 * 60 * 1000,

      // NEW: Track which shopping centers have expanded anchor tenant view
      expandedAnchorTenants: {},

      // Track services found outside 5km radius
      servicesOutsideRadius: [],
      hasExpandedSearch: false,

      // Anchor tenant database for South African retailers - COMPREHENSIVE LIST
      anchorTenants: {
        'supermarket': [
          'Pick n Pay', 'Shoprite', 'Checkers', 'Woolworths', 'Spar',
          'Food Lovers Market', 'Makro', 'Pick n Pay Hyper', 'Checkers Hyper',
          'Shoprite Hyper', 'Woolworths Food', 'Spar Express', 'Boxer',
          'Fruit & Veg City', 'Cambridge Food', 'USave', 'Usave', 'OK Foods',
          'Roots Butchery'
        ],
        'department_store': [
          'Game', 'Edgars', 'Ackermans', 'Pep', 'Jet', 'Mr Price',
          'Truworths', 'Foschini', 'Legit', 'Identity', 'Woolworths',
          'Markham', 'TFG', 'The Fix', 'Factorie', 'Totalsports'
        ],
        'fashion': [
          'Mr Price', 'Truworths', 'Foschini', 'Woolworths Fashion',
          'Legit', 'Identity', 'Ackermans', 'Pep', 'Jet', 'Markham',
          'The Fix', 'Factorie', 'Sportsgirl', 'Duesouth', 'Superbalist'
        ],
        'pharmacy': [
          'Clicks', 'Dis-Chem', 'Medirite', 'Clicks Pharmacy',
          'Dis-Chem Pharmacy', 'Alpha Pharm', 'Link Pharmacies'
        ],
        'electronics': [
          'Game', 'Hifi Corp', 'Incredible Connection', 'Makro',
          'Hirschs', 'Game Electronics', 'Dion Wired', 'Takealot',
          'Makro Electronics'
        ],
        'fast_food': [
          'KFC', 'McDonalds', 'Chicken Licken', 'Nandos',
          'Debonairs Pizza', 'Steers', 'Wimpy', 'Burger King',
          'Romans Pizza', 'Ocean Basket', 'Spur', 'Mugg & Bean',
          'Pie City'
        ],
        'home_improvement': [
          'Builders Warehouse', 'Builders Express', 'Chamberlains',
          'Mica', 'Builders', 'Cashbuild', 'Italtile', 'Tile Africa'
        ],
        'bank': [
          'FNB', 'Standard Bank', 'Absa', 'Nedbank', 'Capitec',
          'FNB ATM', 'Absa ATM', 'Standard Bank ATM', 'Nedbank ATM',
          'Capitec ATM', 'African Bank', 'Bidvest Bank'
        ],
        'specialty': [
          'Exclusive Books', 'CNA', 'Musica', 'Studio 88', 'Sportscene',
          'Total Sports', 'Adidas', 'Nike', 'Puma', 'Toy Kingdom',
          'Crazy Store', 'Boxer Liquors', 'The Courier Guy'
        ]
      },
      // Constants for radii
      EMERGENCY_SERVICE_RADIUS: 5000, // 5km in meters - BASE RADIUS
      EXPANDED_SEARCH_RADIUS_1: 10000, // 10km in meters - FIRST EXPANSION
      EXPANDED_SEARCH_RADIUS_2: 200000, // 200km in meters - SECOND EXPANSION
      SHOPPING_CENTER_RADIUS: 5000,    // 5km in meters - SAME AS EMERGENCY SERVICES
      MAX_ALLOWED_DISTANCE_KM: 5.0,    // Strict 5km limit for initial search

      // PRECISE Anchor tenant database for YOUR PROPERTIES
      yourPropertyTenants: {
        'Grupo Antolin (Waltloo)': [
          'Pick n Pay', 'Edgars', 'Ackermans', 'Clicks', 'FNB',
          'Mr Price', 'Pep', 'Jet', 'Dis-Chem', 'Woolworths',
          'Shoprite', 'Checkers', 'Spar', 'Game', 'Standard Bank',
          'Builders Warehouse', 'KFC', 'Debonairs Pizza'
        ],
        'Atteridgville Waste Center': [
          'Shoprite', 'Edgars', 'Pep', 'Clicks', 'Capitec',
          'Ackermans', 'FNB', 'Mr Price', 'Checkers', 'Dis-Chem',
          'Jet', 'Pick n Pay', 'Standard Bank', 'KFC', 'Steers'
        ]
      },

      // COMPETITOR SHOPPING CENTERS - with actual anchor tenants
      competitorPropertyTenants: {
        'Naledi Mall': [
          'Shoprite', 'Capitec', 'Standard Bank', 'OK Furniture', 'Hungry Lion', 'FNB'
        ],
        'Mikuelo Park Square': [
          'Woolworths', 'Checkers', 'Game', 'Edgars', 'Clicks',
          'Pick n Pay', 'FNB', 'Mr Price', 'Dis-Chem', 'Standard Bank'
        ],
        'Vosloorus Mall': [
          'Shoprite', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Mr Price', 'Ackermans', 'Pep', 'Dis-Chem', 'Jet'
        ],
        'Johannesburg City Mall': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Ackermans'
        ],
        'Sandton City': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Ackermans',
          'Checkers', 'Shoprite', 'Spar'
        ],
        'Eastgate Shopping Centre': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Shoprite'
        ],
        'Menlyn Park': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Ackermans'
        ],
        'Cresta Shopping Centre': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Shoprite'
        ],
        'Gateway Theatre of Shopping': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Ackermans'
        ],
        'Canal Walk': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Shoprite'
        ],
        'Clearwater Mall': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Shoprite'
        ],
        'Mall of Africa': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Ackermans'
        ],
        'Fourways Mall': [
          'Woolworths', 'Pick n Pay', 'Edgars', 'Clicks', 'FNB',
          'Game', 'Mr Price', 'Dis-Chem', 'Standard Bank', 'Shoprite'
        ]
      }
    });
  },
  computed: {
    nearestEmergencyServices() {
      const nearestByType = {};

      this.nearestPlaces.forEach(place => {
        if (!nearestByType[place.type] || place.distance < nearestByType[place.type].distance) {
          nearestByType[place.type] = place;
        }
      });

      return Object.values(nearestByType)
        .sort((a, b) => {
          // Services within 5km come first
          if (a.searchRadius <= 5000 && b.searchRadius > 5000) return -1;
          if (a.searchRadius > 5000 && b.searchRadius <= 5000) return 1;

          // Then sort by distance
          return a.distance - b.distance;
        });
    },

    // Check if any emergency services were found outside the standard 5km radius
    hasServicesOutsideRadius() {
      return this.nearestEmergencyServices.some(service =>
        service.searchRadius && service.searchRadius > 5000
      );
    },

    // Computed property for visible competitor centers (first 3 or all)
    visibleCompetitorCenters() {
      if (this.showAllCompetitorCenters) {
        return this.competitorShoppingCenters.slice(0, 3);
      }
      return this.competitorShoppingCenters.slice(0, 3);
    },

    // Computed property for remaining competitor centers (when showing all)
    remainingCompetitorCenters() {
      if (!this.showAllCompetitorCenters || this.competitorShoppingCenters.length <= 3) {
        return [];
      }
      return this.competitorShoppingCenters.slice(3);
    }
  },
  watch: {
    selectedProperty: {
      handler(newProperty) {
        if (newProperty && newProperty.title) {
          this.identifyPropertyShoppingCenter();
        }
      },
      deep: true,
      immediate: true
    },
    propertyCoordinates: {
      handler(newCoords) {
        if (newCoords) {
          this.propertyLocation = newCoords;
          if (this.map) {
            this.resetMapToProperty();
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    if (localStorage.getItem('map_interaction_enabled') === '1') {
      this.show_map_overlay = false;
      this.mapLoading = true;
      this.initPropertyLocation();

      this.$nextTick(() => {
        this.initMap(true);
      });
    } else {
      this.initPropertyLocation();
    }

    // NEW: listen for outside clicks
    document.addEventListener('click', this.close_map_interaction);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.close_map_interaction);

    if (this.map) {
      this.markers.forEach(marker => marker.setMap(null));
      this.markers = [];
      if (this.radiusCircle) {
        this.radiusCircle.setMap(null);
      }
      Object.values(this.directionsRenderers).forEach(renderer => renderer.setMap(null));
    }
  },
  methods: {
    activate_map() {
      this.show_map_overlay = false;
      localStorage.setItem('map_interaction_enabled', '1');

      if (!this.map) {
        this.mapLoading = true;
        this.$nextTick(() => {
          this.initMap(true);
        });
        return;
      }

      this.map.setOptions({
        gestureHandling: 'auto',
        scrollwheel: true,
        draggable: true,
        keyboardShortcuts: true,
        zoomControl: true,
      });

      google.maps.event.trigger(this.map, 'resize');
    },

    async loadMapDataWithCache() {
      // Check if we have cached map data
      const cachedData = this.getCachedMapData();

      if (cachedData) {
        // Use cached data - much faster!
        const restored = this.restoreMapDataFromCache(cachedData);
        if (restored) {
          this.mapLoading = false;
          // Try to calculate ETAs asynchronously in background if map is ready
          if (this.map) {
            this.calculateETAForAllPlaces().catch(err => {
              console.warn('Failed to update ETAs:', err);
            });
          }
          return;
        }
      }

      // No cache or cache is invalid - make fresh API requests
      await this.findNearestServices();
      await this.findNearestShoppingCenters();

      // Cache the results for next time
      this.setCachedMapData({
        nearestPlaces: this.nearestPlaces,
        nearestByType: this.nearestByType,
        propertyShoppingCenter: this.propertyShoppingCenter,
        propertyAnchorTenants: this.propertyAnchorTenants,
        competitorShoppingCenters: this.competitorShoppingCenters,
        shoppingCenters: this.shoppingCenters
      });
    },

    close_map_interaction(event) {
      // 🔒 If overlay is visible, do nothing
      if (this.show_map_overlay) return;

      if (!this.$refs.map_wrapper) return;

      const clicked_inside_map =
        this.$refs.map_wrapper.contains(event.target);

      if (!clicked_inside_map) {
        this.show_map_overlay = true;
        localStorage.removeItem('map_interaction_enabled');

        if (this.map) {
          this.map.setOptions({
            gestureHandling: 'none',
            scrollwheel: false,
            draggable: false,
            keyboardShortcuts: false,
          });
        }
      }
    },

    // NEW: Toggle expanded view for anchor tenants
    toggleAnchorTenants(center) {
      const centerKey = center.place_id || center.name;
      // Create a new object to trigger reactivity
      this.expandedAnchorTenants = {
        ...this.expandedAnchorTenants,
        [String(centerKey)]: !this.expandedAnchorTenants[String(centerKey)]
      };
    },

    // NEW: Get visible anchor tenants (max 3 initially, more if expanded)
    getVisibleAnchorTenants(center) {
      const centerKey = center.place_id || center.name;
      const tenants = center.anchor_tenants || [];

      if (this.expandedAnchorTenants[String(centerKey)] || tenants.length <= 3) {
        return tenants;
      }
      return tenants.slice(0, 3);
    },

    // NEW: Check if anchor tenants should show "Show More" button
    shouldShowMoreAnchorTenants(center) {
      const centerKey = center.place_id || center.name;
      const tenants = center.anchor_tenants || [];

      return tenants.length > 3 && !this.expandedAnchorTenants[String(centerKey)];
    },

    initPropertyLocation() {
      this.propertyLocation = this.propertyCoordinates || { lat: -26.2041, lng: 28.0473 };
    },

    initMap(interactive = false) {
      if (!this.$refs.mapContainer) {
        this.mapError = true;
        return;
      }

      if (!window.google || !window.google.maps) {
        this.mapError = true;
        return;
      }

      this.mapLoading = true;
      this.directionsService = new google.maps.DirectionsService();

      try {
        this.map = new google.maps.Map(this.$refs.mapContainer, {
          center: this.propertyLocation,
          zoom: 14,
          mapTypeId: this.mapTypeId,

          gestureHandling: interactive ? 'auto' : 'none',
          scrollwheel: interactive,
          draggable: interactive,
          keyboardShortcuts: interactive,
          zoomControl: true,

          styles: this.getMapStyle(),
          mapTypeControl: true,
          streetViewControl: false,
          fullscreenControl: true,
        });

        this.map.setOptions({
          mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'hybrid']
          }
        });

        this.map.setMapTypeId('hybrid');
        this.mapTypeId = 'hybrid';

        // Add radius circle (5km radius)
        this.radiusCircle = new google.maps.Circle({
          strokeColor: '#4285F4',
          strokeOpacity: 0.3,
          strokeWeight: 2,
          fillColor: '#4285F4',
          fillOpacity: 0.1,
          map: this.map,
          center: this.propertyLocation,
          radius: this.EMERGENCY_SERVICE_RADIUS
        });

        const propertyMarker = new google.maps.Marker({
          position: this.propertyLocation,
          map: this.map,
          title: this.locationName,
          icon: {
            url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
            scaledSize: new google.maps.Size(48, 48),
            anchor: new google.maps.Point(24, 48),
          },
          animation: google.maps.Animation.DROP,
          zIndex: 1000
        });

        this.markers.push(propertyMarker);

        this.infoWindow = new google.maps.InfoWindow({
          content: `<div class="map-info-window">
                     <h6 class="text-primary fw-bold">📍 ${this.locationName}</h6>
                     <p>Property Location</p>
                     <p><small>Lat: ${this.propertyLocation.lat.toFixed(4)}<br>
                     Lng: ${this.propertyLocation.lng.toFixed(4)}</small></p>
                     <p><small>Search radius: 5km</small></p>
                   </div>`
        });

        propertyMarker.addListener('click', () => {
          this.infoWindow.open(this.map, propertyMarker);
        });

        this.loadMapDataWithCache();

      } catch (error) {
        this.mapError = true;
      } finally {
        setTimeout(() => {
          this.mapLoading = false;
          if (this.map) {
            google.maps.event.trigger(this.map, 'resize');
          }
        }, 1500);
      }
    },

    // ========== ENHANCED EMERGENCY SERVICE SEARCH WITH EXPANDED RADIUS ==========
    async findNearestServices() {
      if (!this.map) {
        return;
      }

      this.mapLoading = true;
      this.nearestPlaces = []; // This should hold ALL emergency services
      this.servicesOutsideRadius = [];
      this.hasExpandedSearch = false;

      // Clear existing service markers only
      this.markers.slice(1).forEach(marker => marker.setMap(null));
      this.markers = this.markers.slice(0, 1);

      // Update radius circle position
      if (this.radiusCircle) {
        this.radiusCircle.setCenter(this.propertyLocation);
      }

      const center = this.propertyLocation;

      // Define all required service types with metadata
      const REQUIRED_SERVICE_TYPES = [
        { type: 'fire_station', label: 'Fire Station', icon: 'fas fa-fire-extinguisher', color: '#FF4500' },
        { type: 'police', label: 'Police Station', icon: 'fas fa-shield-alt', color: '#4169E1' },
        { type: 'hospital', label: 'Hospital', icon: 'fas fa-hospital', color: '#DC143C' },
        { type: 'gas_station', label: 'Gas Station', icon: 'fas fa-gas-pump', color: '#FFD700' },
      ];

      // Track found service types
      const foundServiceTypes = new Set();
      const allFoundServices = [];
      const missingServiceTypes = [];

      // Helper function to search for ALL services of a specific type within a given radius
      const searchAllServicesOfType = async (serviceType, searchRadius = 5000, maxResults = 3) => {
        const serviceInfo = REQUIRED_SERVICE_TYPES.find(s => s.type === serviceType);
        const searchResults = await this.searchNearbyPlaces(
          serviceType,
          center,
          searchRadius
        );

        if (searchResults && searchResults.length > 0) {
          // Get detailed info for all results (up to maxResults)
          const detailedPromises = searchResults.slice(0, maxResults).map(async (result) => {
            const detailedPlace = await this.getPlaceDetails(result.place_id);
            if (detailedPlace && detailedPlace.geometry && detailedPlace.geometry.location) {
              const latLng = this.getLatLngValue(detailedPlace.geometry.location);
              if (!latLng) return null;
              const distance = this.calculateDistance(
                center.lat, center.lng,
                latLng.lat,
                latLng.lng
              );

              // Add metadata
              const enhancedPlace = {
                ...detailedPlace,
                serviceType: serviceType,
                type: serviceType, // Keep for compatibility
                label: serviceInfo.label,
                icon: serviceInfo.icon,
                color: serviceInfo.color,
                searchRadius: searchRadius,
                distance: distance,
                distance_km: distance,
                display_distance: this.formatDistance(distance),
                outsideStandardRadius: searchRadius > 5000,
                expandedSearchNote: searchRadius > 5000 ?
                  `Found outside 5km radius (${Math.round(searchRadius / 1000)}km search)` : ''
              };
              return enhancedPlace;
            }
            return null;
          });
          const detailedResults = await Promise.all(detailedPromises);
          return detailedResults.filter(place => place !== null);
        }
        return [];
      };

      const phase1Promises = REQUIRED_SERVICE_TYPES.map(async (serviceInfo) => {
        const services = await searchAllServicesOfType(serviceInfo.type, this.EMERGENCY_SERVICE_RADIUS, 2);

        if (services.length > 0) {
          foundServiceTypes.add(serviceInfo.type);
          services.forEach(service => {
            allFoundServices.push(service);
          });
          return true;
        } else {
          missingServiceTypes.push(serviceInfo.type);
          return false;
        }
      });

      await Promise.all(phase1Promises);

      // PHASE 2: Expand search ONLY for service types that had NO results in Phase 1
      if (missingServiceTypes.length > 0) {
        this.hasExpandedSearch = true;
        missingServiceTypes.map(t => REQUIRED_SERVICE_TYPES.find(s => s.type === t).label);

        const phase2Promises = missingServiceTypes.map(async (missingServiceType) => {
          let foundServices = [];

          // Try with 10km radius (first expansion)
          foundServices = await searchAllServicesOfType(missingServiceType, this.EXPANDED_SEARCH_RADIUS_1, 1);

          // If still not found, try 20km (second expansion)
          if (foundServices.length === 0) {
            foundServices = await searchAllServicesOfType(missingServiceType, this.EXPANDED_SEARCH_RADIUS_2, 1);
          }

          if (foundServices.length > 0) {
            foundServiceTypes.add(missingServiceType);
            foundServices.forEach(service => {
              allFoundServices.push(service);
              this.servicesOutsideRadius.push(service);
            });
            return true;
          } else {
            return false;
          }
        });

        await Promise.all(phase2Promises);
      }

      // Sort all services: services within 5km first, then by distance
      allFoundServices.sort((a, b) => {
        // Services within 5km come first
        if (a.searchRadius <= 5000 && b.searchRadius > 5000) return -1;
        if (a.searchRadius > 5000 && b.searchRadius <= 5000) return 1;

        // Then sort by service type priority (police, fire, hospital first)
        const typePriority = {
          'police': 1,
          'fire_station': 2,
          'hospital': 3,
          'pharmacy': 4,
          'gas_station': 5
        };

        const priorityA = typePriority[a.serviceType] || 99;
        const priorityB = typePriority[b.serviceType] || 99;

        if (priorityA !== priorityB) return priorityA - priorityB;

        // Finally sort by distance
        return a.distance - b.distance;
      });

      // Update the component state with ALL found services
      this.nearestPlaces = allFoundServices;

      // Ensure Kenton-on-Sea Clinic is present for Ekuphumleni (manual fallback)
      if (this.selectedProperty && typeof this.selectedProperty.title === 'string' &&
        this.selectedProperty.title.toLowerCase().includes('ekuphumleni')) {

        const hasClinic = this.nearestPlaces.some(p =>
          p.serviceType === 'clinic' && (p.name || '').toLowerCase().includes('kenton-on-sea')
        );

        if (!hasClinic) {
          // Kenton-on-Sea Clinic coordinates provided
          const clinicLat = -33.680646407512604;
          const clinicLng = 26.669799010179574;

          // Calculate distance from property to clinic
          const distanceKm = this.calculateDistance(
            this.propertyLocation.lat,
            this.propertyLocation.lng,
            clinicLat,
            clinicLng
          );

          // Determine if it's within 5km radius (it should be based on your 281m/2 mins data)
          const isWithinStandardRadius = distanceKm <= 5.0; // This should be true for 281m

          // Estimate driving time (assuming 60km/h average speed for accuracy)
          // For 281m, this should be about 1-2 minutes
          const durationSeconds = Math.round((distanceKm / 30) * 3600); // Using 30km/h for more accurate short distances
          const etaText = durationSeconds < 60
            ? '1 min'
            : durationSeconds >= 3600
              ? `${Math.round(durationSeconds / 3600)} hr ${Math.round((durationSeconds % 3600) / 60)} mins`
              : `${Math.round(durationSeconds / 60)} mins`;

          const manualClinic = {
            name: 'Kenton-on-Sea Clinic',
            vicinity: 'Kenton-on-Sea, Eastern Cape',
            serviceType: 'clinic',
            label: 'Medical Clinic',
            icon: 'fas fa-clinic-medical',
            color: '#20B2AA',
            searchRadius: isWithinStandardRadius ? this.EMERGENCY_SERVICE_RADIUS : this.EXPANDED_SEARCH_RADIUS_2,
            distance: distanceKm,
            distance_km: distanceKm,
            distance_meters: distanceKm * 1000,
            display_distance: this.formatDistance(distanceKm),
            outsideStandardRadius: !isWithinStandardRadius, // This will be false for 281m
            expandedSearchNote: !isWithinStandardRadius ? 'Manual fallback added: Kenton-on-Sea Clinic' : '',
            manual: true,
            formatted_phone_number: '+27 46 648 2411',
            eta: etaText,
            duration_seconds: durationSeconds,
            geometry: {
              location: {
                lat: clinicLat,
                lng: clinicLng
              }
            }
          };

          this.nearestPlaces.push(manualClinic);
          // Only add to servicesOutsideRadius if it's actually outside 5km
          if (!isWithinStandardRadius) {
            this.servicesOutsideRadius.push(manualClinic);
          }
        }
      }

      // ========== ADD GANYESA FIRE STATION FALLBACK HERE ==========
      // Ensure Vryburg Fire & Rescue is present for Ganyesa (manual fallback)
      if (this.selectedProperty && typeof this.selectedProperty.title === 'string' &&
        this.selectedProperty.title.toLowerCase().includes('ganyesa')) {

        const hasVryburg = this.nearestPlaces.some(p =>
          p.serviceType === 'fire_station' && (p.name || '').toLowerCase().includes('vryburg')
        );

        if (!hasVryburg) {
          // Vryburg Fire & Rescue exact coordinates
          const fire_station_lat = -26.95761089704646;
          const fire_station_lng = 24.72607927052597;

          // Calculate distance from property to fire station
          const distance_km = this.calculateDistance(
            this.propertyLocation.lat,
            this.propertyLocation.lng,
            fire_station_lat,
            fire_station_lng
          );

          // Determine if it's within 5km radius
          const is_within_standard_radius = distance_km <= 5.0;

          // Estimate driving time (assuming 60km/h average speed)
          const duration_seconds = Math.round((distance_km / 60) * 3600);
          const eta_text = duration_seconds >= 3600
            ? `${Math.round(duration_seconds / 3600)} hr ${Math.round((duration_seconds % 3600) / 60)} mins`
            : `${Math.round(duration_seconds / 60)} mins`;

          const manual_fire_station = {
            name: 'Vryburg Fire & Rescue',
            vicinity: 'Vryburg, North West',
            serviceType: 'fire_station',
            label: 'Fire Station',
            icon: 'fas fa-fire-extinguisher',
            color: '#FF4500',
            searchRadius: is_within_standard_radius ? this.EMERGENCY_SERVICE_RADIUS : this.EXPANDED_SEARCH_RADIUS_2,
            distance: distance_km,
            distance_km: distance_km,
            distance_meters: distance_km * 1000,
            display_distance: this.formatDistance(distance_km),
            outsideStandardRadius: !is_within_standard_radius,
            expandedSearchNote: !is_within_standard_radius ? 'Manual fallback added: Vryburg Fire & Rescue' : '',
            manual: true,
            formatted_phone_number: '+27 53 998 0000',
            eta: eta_text,
            duration_seconds: duration_seconds,
            geometry: {
              location: {
                lat: fire_station_lat,
                lng: fire_station_lng
              }
            }
          };

          this.nearestPlaces.push(manual_fire_station);

          // Only add to servicesOutsideRadius if actually outside 5km
          if (!is_within_standard_radius) {
            this.servicesOutsideRadius.push(manual_fire_station);
          }
        }
      }

      // Add markers for all found services
      this.nearestPlaces.forEach(place => {
        this.addPlaceMarker(place);
      });
      // Calculate ETAs for all found services
      await this.calculateETAForAllPlaces();
      this.mapLoading = false;
      // Force UI update
      this.$forceUpdate();
    },

    getPlacesApiKey() {
      return process.env.VUE_APP_GOOGLE_MAPS_API_KEY || '';
    },

    getPlacesHeaders(fieldMask) {
      return ({ 'Content-Type': 'application/json', 'X-Goog-Api-Key': this.getPlacesApiKey(), 'X-Goog-FieldMask': fieldMask });
    },

    get_current_property_cache_key() {
      const title = this.selectedProperty && this.selectedProperty.title
        ? String(this.selectedProperty.title).trim().toLowerCase()
        : 'unknown';
      const coords = this.propertyLocation || this.propertyCoordinates;
      if (coords && typeof coords.lat === 'number' && typeof coords.lng === 'number') {
        return `${title}|${coords.lat.toFixed(4)},${coords.lng.toFixed(4)}`;
      }
      return title || 'unknown';
    },

    build_places_cache_key(scope, parts, includeProperty = true) {
      const payload = (includeProperty
        ? { scope, property: this.get_current_property_cache_key(), ...parts }
        : ({ scope, ...parts }));
      return (`${this.places_cache_prefix}:${encodeURIComponent(JSON.stringify(payload))}`);
    },

    get_places_cache_entry(cache_key) {
      const now = Date.now();
      const inMemory = this.places_cache[String(cache_key)];
      if (inMemory && now - inMemory.ts < this.places_cache_ttl_ms) {
        return inMemory.data;
      }
      if (inMemory && now - inMemory.ts >= this.places_cache_ttl_ms) {
        this.places_cache[String(cache_key)] = null;
      }

      try {
        const raw = localStorage.getItem(cache_key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.ts !== 'number') {
          localStorage.removeItem(cache_key);
          return null;
        }
        if (now - parsed.ts >= this.places_cache_ttl_ms) {
          localStorage.removeItem(cache_key);
          return null;
        }
        this.places_cache[String(cache_key)] = parsed;
        return parsed.data;
      } catch (error) {
        return null;
      }
    },

    set_places_cache_entry(cache_key, data) {
      const entry = { ts: Date.now(), data };
      this.places_cache[String(cache_key)] = entry;
      try {
        localStorage.setItem(cache_key, JSON.stringify(entry));
      } catch (error) {
        // Ignore cache write failures (quota, disabled storage, etc.)
      }
    },

    // ========== MAP DATA CACHING METHODS ==========
    getMapDataCacheKeyForStorage() {
      return `map_data_cache_${this.get_current_property_cache_key()}`;
    },

    getCachedMapData() {
      const cacheKey = this.getMapDataCacheKeyForStorage();
      const now = Date.now();

      try {
        const raw = localStorage.getItem(cacheKey);
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed.ts !== 'number') {
          localStorage.removeItem(cacheKey);
          return null;
        }

        // Check if cache is still valid (24 hours)
        if (now - parsed.ts >= this.places_cache_ttl_ms) {
          localStorage.removeItem(cacheKey);
          return null;
        }

        return parsed.data;
      } catch (error) {
        console.warn('Failed to retrieve map data from cache:', error);
        return null;
      }
    },

    setCachedMapData(data) {
      const cacheKey = this.getMapDataCacheKeyForStorage();
      const entry = { ts: Date.now(), data };

      try {
        localStorage.setItem(cacheKey, JSON.stringify(entry));
      } catch (error) {
        console.warn('Failed to cache map data:', error);
      }
    },

    restoreMapDataFromCache(cachedData) {
      // Restore all the cached data
      this.nearestPlaces = cachedData.nearestPlaces || [];
      this.nearestByType = cachedData.nearestByType || {};
      this.propertyShoppingCenter = cachedData.propertyShoppingCenter || null;
      this.propertyAnchorTenants = cachedData.propertyAnchorTenants || [];
      this.competitorShoppingCenters = cachedData.competitorShoppingCenters || [];
      this.shoppingCenters = cachedData.shoppingCenters || [];

      if (this.propertyShoppingCenter) {
        this.assignPropertyAnchorTenants(this.propertyShoppingCenter);
      }

      // Add markers for all cached services
      this.nearestPlaces.forEach(place => {
        this.addPlaceMarker(place);
      });

      this.$forceUpdate();
      return true;
    },

    handlePlacesUnavailable(message) {
      console.warn(message);
      return [];
    },

    getLatLngValue(location) {
      if (!location) return null;
      if (typeof location.lat === 'function' && typeof location.lng === 'function') return ({ lat: location.lat(), lng: location.lng() });
      if (typeof location.latitude === 'number' && typeof location.longitude === 'number') return ({ lat: location.latitude, lng: location.longitude });
      if (typeof location.lat === 'number' && typeof location.lng === 'number') return ({ lat: location.lat, lng: location.lng });
      return null;
    },

    normalizePlaceData(place) {
      const latLng = this.getLatLngValue(place.location || (place.geometry && place.geometry.location));
      if (!latLng) return null;

      let placeId = place.id || place.place_id || null;
      if (!placeId && typeof place.name === 'string' && place.name.startsWith('places/')) placeId = place.name.replace('places/', '');

      let displayName = '';
      if (place.displayName && typeof place.displayName.text === 'string') displayName = place.displayName.text;
      else if (typeof place.displayName === 'string') displayName = place.displayName;
      else if (typeof place.name === 'string' && !place.name.startsWith('places/')) displayName = place.name;

      const formattedAddress = place.formattedAddress || place.formatted_address || place.vicinity || '';

      return ({
        place_id: placeId || undefined,
        name: displayName || 'Unknown',
        formatted_address: formattedAddress,
        vicinity: formattedAddress,
        geometry: {
          location: { lat: latLng.lat, lng: latLng.lng }
        },
        types: place.types || [],
        rating: place.rating,
        user_ratings_total: place.userRatingCount,
        business_status: place.businessStatus,
        formatted_phone_number: place.internationalPhoneNumber || place.nationalPhoneNumber || place.formatted_phone_number,
        website: place.websiteUri || place.website
      });
    },

    // Helper method for searching nearby places (Places API New)
    async searchNearbyPlaces(type, coordinates, radius = 5000, maxResults = 20) {
      if (!this.map) return this.handlePlacesUnavailable('Map not ready');
      if (!this.getPlacesApiKey()) return this.handlePlacesUnavailable('Missing Google Maps API key for Places API (New)');

      try {
        const response = await fetch('https://places.googleapis.com/v1/places:searchNearby', {
          method: 'POST',
          headers: this.getPlacesHeaders(
            'places.id,places.displayName,places.location,places.formattedAddress,places.types,places.primaryType,places.businessStatus,places.rating,places.userRatingCount'
          ),
          body: JSON.stringify({
            includedTypes: [type],
            maxResultCount: maxResults, // Fetch slightly more to account for filtered out items
            rankPreference: 'DISTANCE',
            languageCode: 'en',
            locationRestriction: {
              circle: {
                center: {
                  latitude: coordinates.lat,
                  longitude: coordinates.lng
                },
                radius: radius
              }
            }
          })
        });

        if (!response.ok) {
          console.warn(`Places API (New) error for ${type}:`, response.status);
          return [];
        }

        const data = await response.json();

        let places = (data.places || [])
          .map(place => this.normalizePlaceData(place))
          .filter(Boolean);

        // Enhanced filtering to specifically exclude private doctors when searching for hospitals/clinics
        // Google Places API notoriously returns private practices under 'hospital' type
        if (type === 'hospital' || type === 'clinic') {
          const private_practice_keywords = [
            'dr', 'dr.', 'doctor', 'doctors', 'physician',
            'surgery', 'surgeries', 'specialist', 'specialists',
            'dental', 'dentist', 'physio', 'physiotherapy',
            'optometrist', 'optometry', 'orthodontist',
            'dermatologist', 'dietician', 'psychologist',
            'psychiatrist', 'chiropractor', 'pediatrician',
            'gynaecologist', 'urologist', 'cardiologist',
            'surgeon', 'medical centre', 'medical center',
            // Adding some common Afrikaans/South African private practice words
            'spreekkamer', 'praktyk', 'fisioterapeut',
            'tandarts', 'oogarts'
          ];

          const private_types = [
            'doctor', 'dentist', 'physiotherapist',
            'health', 'medical_clinic' // Often private
          ];

          // Explicitly good keywords for public/large hospitals
          const public_hospital_keywords = [
            'hospital', 'hospitaal', 'clinic', 'kliniek',
            'provincial', 'provinsiale', 'district', 'distrik',
            'general', 'algemene', 'municipal', 'state'
          ];

          places = places.filter(place => {
            const name_lower = (place.name || '').toLowerCase();

            // 1. Check if the place strongly identifies as a hospital/clinic by name
            const has_hospital_keyword = public_hospital_keywords.some(keyword => name_lower.includes(keyword));

            // 2. Check for private practice keywords using simple string matching with word boundaries
            const has_private_keyword = private_practice_keywords.some(keyword => {
              const keyword_lower = keyword.toLowerCase();

              // Simple word boundary check: look for the keyword surrounded by non-letter characters or string boundaries
              // This avoids RegExp constructor completely
              const name_with_spaces = ` ${name_lower} `; // Add spaces to handle word boundaries

              // Check if the keyword appears as a whole word by looking for it with spaces/punctuation around it
              return (
                name_with_spaces.includes(` ${keyword_lower} `) ||
                name_with_spaces.includes(` ${keyword_lower}.`) ||
                name_with_spaces.includes(` ${keyword_lower},`) ||
                name_with_spaces.includes(` ${keyword_lower}-`) ||
                name_with_spaces.includes(`-${keyword_lower} `) ||
                name_with_spaces.startsWith(`${keyword_lower} `) ||
                name_with_spaces.endsWith(` ${keyword_lower}`)
              );
            });

            // 3. Check Google's types for private indicators
            const has_private_type = Array.isArray(place.types) && place.types.some(t => private_types.includes(t));

            // Decision matrix:
            // If it has strong hospital keywords, KEEP IT (even if it has 'medical centre')
            if (has_hospital_keyword && !name_lower.includes('dr ') && !name_lower.includes('dr.')) {
              return true;
            }

            // If it has private keywords OR private types, EXCLUDE IT
            if (has_private_keyword || has_private_type) {
              return false;
            }

            // Default: KEEP IT (it passed the exclusion filters)
            return true;
          });

          // If we filtered out too many, we still abide by maxResults
          places = places.slice(0, maxResults);
        }

        places = places.map(place => {
          const latLng = this.getLatLngValue(place.geometry && place.geometry.location);
          const distance = latLng
            ? this.calculateDistance(
              coordinates.lat,
              coordinates.lng,
              latLng.lat,
              latLng.lng
            )
            : 0;

          return ({
            ...place,
            distance: distance,
            serviceType: type
          });
        });

        return places;
      } catch (error) {
        console.warn(`Places API (New) request failed for ${type}:`, error);
        return [];
      }
    },

    // Identify if the current property has a shopping center in our database
    identifyPropertyShoppingCenter() {
      if (!this.selectedProperty || !this.selectedProperty.title) {
        this.propertyShoppingCenter = null;
        this.propertyAnchorTenants = [];
        return;
      }

      const propertyName = this.selectedProperty.title;
      const propertyNameLower = propertyName.toLowerCase();

      // Check if this property is in our yourPropertyTenants database
      let foundExactMatch = false;

      Object.entries(this.yourPropertyTenants).forEach(([shoppingCenterName, tenants]) => {
        const shoppingCenterLower = shoppingCenterName.toLowerCase();

        // Check for exact match or partial match
        if (propertyNameLower.includes(shoppingCenterLower) || shoppingCenterLower.includes(propertyNameLower)) {
          foundExactMatch = true;

          // Format tenants for display
          this.propertyAnchorTenants = tenants.map(tenant => {
            let foundCategory = 'other';
            Object.entries(this.anchorTenants).forEach(([category, tenantList]) => {
              if (tenantList.includes(tenant)) {
                foundCategory = category;
              }
            });

            return ({
              name: tenant,
              category: foundCategory,
              source: 'property_database',
              assumed: false
            });
          });

          // Create a placeholder shopping center object for the property
          this.propertyShoppingCenter = {
            name: propertyName,
            vicinity: this.selectedProperty.address || 'Address not available',
            distance: 0, // Will be updated when we find the actual shopping center
            eta: 'At property',
            isProperty: true,
            // Attach anchor_tenants so the template (which expects center.anchor_tenants) can render them
            anchor_tenants: this.propertyAnchorTenants
          };
        }
      });

      if (!foundExactMatch) {
        this.propertyShoppingCenter = null;
        this.propertyAnchorTenants = [];
      }
    },

    async findNearestShoppingCenters() {
      if (!this.map) {
        return;
      }

      this.shoppingCenters = [];
      this.competitorShoppingCenters = [];

      const center = this.propertyLocation;

      try {
        const searchResults = await this.searchNearbyPlaces(
          'shopping_mall',
          center,
          this.SHOPPING_CENTER_RADIUS,
          20
        );

        const detailedPromises = searchResults.map(async (place) => {
          const detailedPlace = place.place_id ? await this.getPlaceDetails(place.place_id) : place;
          const resolvedPlace = detailedPlace || place;

          if (resolvedPlace && resolvedPlace.geometry && resolvedPlace.geometry.location) {
            const latLng = this.getLatLngValue(resolvedPlace.geometry.location);
            if (!latLng) return null;

            const distance = this.calculateDistance(
              center.lat,
              center.lng,
              latLng.lat,
              latLng.lng
            );

            if (distance <= this.MAX_ALLOWED_DISTANCE_KM) {
              const detectedTenants = this.detectAnchorTenants(resolvedPlace);
              const isPropertyCenter = this.isPropertyShoppingCenter(resolvedPlace);

              return ({
                ...resolvedPlace,
                type: 'shopping_mall',
                category: 'shopping',
                icon: isPropertyCenter ? 'fas fa-store text-success' : 'fas fa-shopping-cart text-purple',
                label: 'Shopping Centre',
                distance: distance,
                distance_km: distance,
                display_distance: this.formatDistance(distance),
                anchor_tenants: detectedTenants,
                competitor_score: this.calculateCompetitorScore(resolvedPlace, detectedTenants),
                isPropertyCenter: isPropertyCenter
              });
            }
          }
          return null;
        });

        const detailedCenters = await Promise.all(detailedPromises);
        const validCenters = detailedCenters.filter(center => center !== null);

        const uniqueCenters = this.removeDuplicateShoppingCenters(validCenters);
        this.shoppingCenters = uniqueCenters
          .sort((a, b) => a.distance - b.distance)
          .slice(0, 6);

        // Separate property shopping centers from competitors
        this.separatePropertyAndCompetitorCenters();

        this.shoppingCenters.forEach(center => {
          this.addShoppingCenterMarker(center);
        });

        await this.calculateETAForShoppingCenters();
        this.$forceUpdate();

      } catch (error) {
        console.error('Error finding shopping centers:', error);
      }
    },

    // Check if a shopping center is the CURRENT property center
    isPropertyShoppingCenter(place) {
      if (!this.selectedProperty || !this.selectedProperty.title) return false;

      const propertyName = this.selectedProperty.title.toLowerCase();
      const placeName = (place.name || '').toLowerCase();

      // Check for direct match first
      if (placeName.includes(propertyName) || propertyName.includes(placeName)) {
        return true;
      }

      // Check if this shopping center is in our property tenants database AND matches the current property
      let isCurrentPropertyCenter = false;
      Object.keys(this.yourPropertyTenants).forEach(shoppingCenterName => {
        const shoppingCenterLower = shoppingCenterName.toLowerCase();

        // Check if the place name matches a shopping center in our database
        if (placeName.includes(shoppingCenterLower) || shoppingCenterLower.includes(placeName)) {
          // Also check if this shopping center name matches the current property name
          if (shoppingCenterLower.includes(propertyName) || propertyName.includes(shoppingCenterLower)) {
            isCurrentPropertyCenter = true;
          }
        }
      });

      return isCurrentPropertyCenter;
    },

    // Separate property shopping centers from competitor centers
    separatePropertyAndCompetitorCenters() {
      this.competitorShoppingCenters = [];

      this.shoppingCenters.forEach(center => {
        // Check if this is the current property's shopping center
        const isCurrentPropertyCenter = this.isPropertyShoppingCenter(center);

        if (isCurrentPropertyCenter) {
          this.handleCurrentPropertyCenter(center);
        } else {
          // This is NOT the current property - it's either a competitor or another one of your properties
          const isYourOtherProperty = this.checkIfYourOtherProperty(center);

          // Only add to competitors if it's NOT your current property AND NOT your other property
          if (!isYourOtherProperty) {
            this.competitorShoppingCenters.push(center);
          }
        }
      });

      // Sort competitor centers by distance
      this.competitorShoppingCenters.sort((a, b) => a.distance - b.distance);
    },

    // Helper method to handle current property center
    handleCurrentPropertyCenter(center) {
      // This is the current property's shopping center - update the property shopping center object
      if (this.propertyShoppingCenter) {
        // Preserve any anchor tenants already set from our property database
        const preservedAnchors = (this.propertyShoppingCenter.anchor_tenants && this.propertyShoppingCenter.anchor_tenants.length)
          ? this.propertyShoppingCenter.anchor_tenants
          : (center.anchor_tenants || []);

        this.propertyShoppingCenter = {
          ...this.propertyShoppingCenter,
          ...center,
          // Ensure property-provided anchors take precedence
          anchor_tenants: preservedAnchors,
          eta: center.eta || this.propertyShoppingCenter.eta || 'At property',
          distance: center.distance || this.propertyShoppingCenter.distance || 0
        };

        // Also keep the separate propertyAnchorTenants array in sync
        this.propertyAnchorTenants = preservedAnchors;
      } else {
        // Create property shopping center if not already created
        this.propertyShoppingCenter = {
          ...center,
          isProperty: true
        };

        this.assignPropertyAnchorTenants(center);
      }
    },


    // Helper method to assign anchor tenants for property
    assignPropertyAnchorTenants(center) {
      // Get anchor tenants for this property
      Object.entries(this.yourPropertyTenants).forEach(([shoppingCenterName, tenants]) => {
        const shoppingCenterLower = shoppingCenterName.toLowerCase();
        const placeName = (center.name || '').toLowerCase();

        if (placeName.includes(shoppingCenterLower) || shoppingCenterLower.includes(placeName)) {
          this.propertyAnchorTenants = tenants.map(tenant => {
            let foundCategory = 'other';
            Object.entries(this.anchorTenants).forEach(([category, tenantList]) => {
              if (tenantList.includes(tenant)) {
                foundCategory = category;
              }
            });

            return ({
              name: tenant,
              category: foundCategory,
              source: 'property_database',
              assumed: false
            });
          });

          // Attach anchor_tenants to the center so templates using center.anchor_tenants render correctly
          center.anchor_tenants = this.propertyAnchorTenants;
          // If we already have a propertyShoppingCenter object for this property, attach there too
          if (this.propertyShoppingCenter && this.propertyShoppingCenter.name && this.propertyShoppingCenter.name.toLowerCase().includes(shoppingCenterLower)) {
            this.propertyShoppingCenter.anchor_tenants = this.propertyAnchorTenants;
          }
        }
      });
    },


    // Helper method to check if a center is one of your other properties
    checkIfYourOtherProperty(center) {
      if (!this.selectedProperty || !this.selectedProperty.title) {
        return false;
      }

      const placeName = (center.name || '').toLowerCase();
      const currentPropertyName = this.selectedProperty.title.toLowerCase();

      // Check all properties in your database
      for (const shoppingCenterName of Object.keys(this.yourPropertyTenants)) {
        const shoppingCenterLower = shoppingCenterName.toLowerCase();

        // Check if the center name matches a property name
        if (placeName.includes(shoppingCenterLower) || shoppingCenterLower.includes(placeName)) {
          // Check if this is a DIFFERENT property than the one we're viewing
          const namesMatch =
            placeName.includes(currentPropertyName) ||
            currentPropertyName.includes(placeName) ||
            shoppingCenterLower.includes(currentPropertyName) ||
            currentPropertyName.includes(shoppingCenterLower);

          // If names DON'T match, it's one of your other properties
          if (!namesMatch) {
            return true;
          }
        }
      }

      return false;
    },

    // Display helper: prefer short property name (e.g., show "Ganyesa" instead of long Google place names)
    getPropertyDisplayName(center) {
      if (!center) return '';
      const raw = (center.name || '').trim();
      const propertyName = (this.selectedProperty && this.selectedProperty.title) ? this.selectedProperty.title.trim() : '';
      if (propertyName && raw.toLowerCase().includes(propertyName.toLowerCase())) {
        // If the place name includes the property name, prefer the short property name
        return propertyName;
      }
      return raw;
    },

    detectAnchorTenants(place) {
      const detectedTenants = [];
      const placeName = (place.name || '').toLowerCase();
      const placeAddress = (place.vicinity || place.formatted_address || '').toLowerCase();
      const searchText = placeName + ' ' + placeAddress;

      // Check competitor database FIRST (only for actual competitors)
      Object.entries(this.competitorPropertyTenants).forEach(([shoppingCenterName, tenants]) => {
        const shoppingCenterLower = shoppingCenterName.toLowerCase();

        if (placeName.includes(shoppingCenterLower) || shoppingCenterLower.includes(placeName)) {
          tenants.forEach(tenant => {
            let foundCategory = 'other';
            Object.entries(this.anchorTenants).forEach(([category, tenantList]) => {
              if (tenantList.includes(tenant)) {
                foundCategory = category;
              }
            });

            detectedTenants.push({
              name: tenant,
              category: foundCategory,
              source: 'competitor_database',
              assumed: false
            });
          });
        }
      });

      // Check for any anchor tenants from the search text
      if (detectedTenants.length === 0) {
        Object.entries(this.anchorTenants).forEach(([category, tenants]) => {
          tenants.forEach(tenant => {
            const tenantLower = tenant.toLowerCase();
            if (searchText.includes(tenantLower)) {
              detectedTenants.push({
                name: tenant,
                category: category,
                source: 'detected_in_text',
                assumed: false
              });
            }
          });
        });
      }

      // If still no tenants, use type-based tenants
      if (detectedTenants.length === 0) {
        const typeBasedTenants = this.getTypeBasedAnchorTenants(place);
        typeBasedTenants.forEach(tenant => {
          detectedTenants.push({
            name: tenant.name,
            category: tenant.category,
            source: 'type_based',
            assumed: true // Mark as assumed for competitors
          });
        });
      }

      // Remove duplicates
      const uniqueTenants = [];
      const seenNames = new Set();

      detectedTenants.forEach(tenant => {
        if (!seenNames.has(tenant.name)) {
          seenNames.add(tenant.name);
          uniqueTenants.push(tenant);
        }
      });

      return uniqueTenants;
    },

    getTypeBasedAnchorTenants(place) {
      const placeName = (place.name || '').toLowerCase();
      const placeTypes = place.types || [];

      if (placeName.includes('mall') || placeName.includes('square') ||
        placeName.includes('centre') || placeName.includes('center')) {
        return [
          { name: 'Pick n Pay', category: 'supermarket' },
          { name: 'Shoprite', category: 'supermarket' },
          { name: 'Checkers', category: 'supermarket' },
          { name: 'Edgars', category: 'department_store' },
          { name: 'Clicks', category: 'pharmacy' },
          { name: 'FNB', category: 'bank' },
          { name: 'Mr Price', category: 'fashion' },
          { name: 'Ackermans', category: 'department_store' },
          { name: 'Dis-Chem', category: 'pharmacy' },
          { name: 'Standard Bank', category: 'bank' }
        ];
      }

      if (placeTypes.includes('shopping_mall')) {
        return [
          { name: 'Pick n Pay', category: 'supermarket' },
          { name: 'Shoprite', category: 'supermarket' },
          { name: 'Woolworths', category: 'supermarket' },
          { name: 'Edgars', category: 'department_store' },
          { name: 'Game', category: 'electronics' },
          { name: 'Clicks', category: 'pharmacy' },
          { name: 'FNB', category: 'bank' },
          { name: 'Standard Bank', category: 'bank' },
          { name: 'Mr Price', category: 'fashion' },
          { name: 'Ackermans', category: 'department_store' }
        ];
      }

      return [
        { name: 'Pick n Pay', category: 'supermarket' },
        { name: 'Shoprite', category: 'supermarket' },
        { name: 'Checkers', category: 'supermarket' },
        { name: 'Edgars', category: 'department_store' },
        { name: 'Clicks', category: 'pharmacy' },
        { name: 'FNB', category: 'bank' },
        { name: 'Mr Price', category: 'fashion' }
      ];
    },

    calculateCompetitorScore(place, tenants) {
      let score = 0;

      if (place.types && place.types.includes('shopping_mall')) {
        score += 80;
      } else if (place.types && place.types.includes('department_store')) {
        score += 60;
      } else if (place.types && place.types.includes('supermarket')) {
        score += 40;
      }

      const tenantCount = tenants.length;
      score += Math.min(tenantCount * 15, 60);

      const majorTenants = ['Pick n Pay', 'Shoprite', 'Woolworths', 'Edgars', 'Game'];
      const majorTenantCount = tenants.filter(t => majorTenants.includes(t.name)).length;
      score += majorTenantCount * 10;

      if (tenants.some(t => t.source === 'competitor_database')) {
        score += 30;
      }

      return Math.min(score, 100);
    },

    removeDuplicateShoppingCenters(centers) {
      const uniqueCenters = [];
      const seenNames = new Set();

      centers.forEach(center => {
        const name = center.name.toLowerCase().trim();
        if (!seenNames.has(name)) {
          seenNames.add(name);
          uniqueCenters.push(center);
        }
      });

      return uniqueCenters;
    },

    addShoppingCenterMarker(center) {
      if (!center.geometry || !center.geometry.location) return;

      const marker = new google.maps.Marker({
        position: center.geometry.location,
        map: this.map,
        title: `${center.name} (Shopping Centre - ${center.display_distance})`,
        icon: this.getShoppingCenterIcon(center),
        animation: google.maps.Animation.DROP
      });

      marker.addListener('click', () => {
        const container = document.createElement('div');
        container.className = 'map-info-window';
        container.style.maxWidth = '300px';

        const title = document.createElement('h6');
        title.className = center.isPropertyCenter ? 'text-success' : 'text-primary';
        title.textContent = center.name;
        container.appendChild(title);

        const type = document.createElement('p');
        if (center.isPropertyCenter) {
          type.innerHTML = '<strong>Your Property Shopping Centre</strong>';
        } else {
          type.innerHTML = '<strong>Shopping Centre / Mall</strong>';
        }
        container.appendChild(type);

        if (center.vicinity) {
          const vicinity = document.createElement('p');
          const vicinitySmall = document.createElement('small');
          vicinitySmall.textContent = center.vicinity;
          vicinity.appendChild(vicinitySmall);
          container.appendChild(vicinity);
        }

        const tenantsSection = document.createElement('div');
        tenantsSection.className = 'mt-2';

        const tenantsLabel = document.createElement('p');
        tenantsLabel.className = 'mb-1';
        tenantsLabel.innerHTML = '<strong>Anchor Tenants:</strong>';
        tenantsSection.appendChild(tenantsLabel);

        const tenantsList = document.createElement('div');
        tenantsList.className = 'd-flex flex-wrap';

        if (center.anchor_tenants && center.anchor_tenants.length > 0) {
          center.anchor_tenants.forEach(tenant => {
            const badge = document.createElement('span');
            badge.className = `badge ${this.getTenantCategoryClass(tenant.category)} me-1 mb-1`;

            let titleText = tenant.name;
            if (tenant.source === 'property_database') titleText += ' (Confirmed anchor tenant)';
            if (tenant.source === 'competitor_database') titleText += ' (Confirmed anchor tenant)';
            if (tenant.source === 'detected_in_text') titleText += ' (Detected in shopping centre information)';
            if (tenant.source === 'type_based') titleText += ' (Typical anchor tenant)';

            badge.textContent = tenant.name + (tenant.assumed ? '*' : '');
            badge.title = titleText;
            tenantsList.appendChild(badge);
          });
        }

        tenantsSection.appendChild(tenantsList);
        container.appendChild(tenantsSection);

        const distanceSection = document.createElement('div');
        distanceSection.className = 'mt-2';

        const distanceEl = document.createElement('p');
        distanceEl.className = 'mb-0';

        const distanceSmall = document.createElement('small');
        distanceSmall.textContent = `${center.display_distance} from property`;
        distanceEl.appendChild(distanceSmall);

        if (center.eta) {
          distanceEl.appendChild(document.createElement('br'));
          const etaSmall = document.createElement('small');
          etaSmall.textContent = `ETA: ${center.eta} by car`;
          distanceEl.appendChild(etaSmall);
        }

        distanceEl.appendChild(document.createElement('br'));
        const radiusSmall = document.createElement('small');
        radiusSmall.textContent = `Within 5km search radius (actual: ${center.distance.toFixed(2)}km)`;
        distanceEl.appendChild(radiusSmall);

        distanceSection.appendChild(distanceEl);
        container.appendChild(distanceSection);

        if (center.website) {
          const websiteSection = document.createElement('div');
          websiteSection.className = 'mt-2';

          const button = document.createElement('button');
          button.className = 'btn btn-sm btn-outline-success';
          button.innerHTML = '<i class="fas fa-globe"></i> Website';
          button.addEventListener('click', () => {
            window.open(center.website, '_blank');
          });

          websiteSection.appendChild(button);
          container.appendChild(websiteSection);
        }

        if (this.infoWindow) {
          this.infoWindow.close();
        }

        this.infoWindow = new google.maps.InfoWindow({ content: container });
        this.infoWindow.open(this.map, marker);
      });

      this.markers.push(marker);
    },

    getShoppingCenterIcon(center) {
      if (center.isPropertyCenter) {
        return ({
          url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
          scaledSize: new google.maps.Size(42, 42),
          anchor: new google.maps.Point(21, 42)
        });
      }

      let iconColor = 'purple';
      if (center.competitor_score >= 80) {
        iconColor = 'red';
      } else if (center.competitor_score >= 60) {
        iconColor = 'orange';
      } else if (center.competitor_score >= 40) {
        iconColor = 'yellow';
      }

      return ({
        url: `https://maps.google.com/mapfiles/ms/icons/${iconColor}-dot.png`,
        scaledSize: new google.maps.Size(42, 42),
        anchor: new google.maps.Point(21, 42)
      });
    },

    getTenantCategoryClass(category) {
      const classMap = {
        'supermarket': 'bg-success',
        'department_store': 'bg-primary',
        'fashion': 'bg-info',
        'pharmacy': 'bg-warning text-dark',
        'electronics': 'bg-secondary',
        'fast_food': 'bg-danger',
        'home_improvement': 'bg-dark',
        'bank': 'bg-light text-dark',
        'specialty': 'bg-purple',
        'other': 'bg-secondary'
      };

      return classMap[String(category)] || 'bg-secondary';
    },

    getTenantTooltip(tenant) {
      if (tenant.source === 'property_database') return 'Confirmed anchor tenant for this property';
      if (tenant.source === 'competitor_database') return 'Confirmed anchor tenant for this competitor';
      if (tenant.source === 'detected_in_text') return 'Anchor tenant detected in shopping centre information';
      if (tenant.source === 'type_based') return 'Typical anchor tenant for this type of shopping centre';
      return 'Anchor tenant';
    },

    getCompetitionLevelClass(score) {
      if (score >= 80) return 'bg-danger';
      if (score >= 60) return 'bg-warning text-dark';
      if (score >= 40) return 'bg-info';
      return 'bg-secondary';
    },

    getCompetitionLevelText(score) {
      if (score >= 80) return 'High';
      if (score >= 60) return 'Medium-High';
      if (score >= 40) return 'Medium';
      if (score >= 20) return 'Low-Medium';
      return 'Low';
    },

    async getPlaceDetails(placeId) {
      if (!placeId || !this.getPlacesApiKey()) return null;

      try {
        const response = await fetch(`https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}`, {
          method: 'GET',
          headers: this.getPlacesHeaders(
            'id,displayName,formattedAddress,location,internationalPhoneNumber,nationalPhoneNumber,websiteUri,types,primaryType,rating,userRatingCount,businessStatus,regularOpeningHours,utcOffsetMinutes'
          )
        });

        if (!response.ok) {
          return null;
        }

        const place = await response.json();
        return this.normalizePlaceData(place);
      } catch (error) {
        return null;
      }
    },

    addPlaceMarker(place) {
      if (!place.geometry || !place.geometry.location) return;

      const marker = new google.maps.Marker({
        position: place.geometry.location,
        map: this.map,
        title: `${place.name} (${place.label || place.type} - ${place.display_distance || this.formatDistance(place.distance)})`,
        icon: this.getMarkerIcon(place.type)
      });

      marker.addListener('click', () => {
        const content = `
          <div class="map-info-window">
            <h6>${place.name}</h6>
            <p><strong>${place.label || place.type}</strong></p>
            ${place.outsideStandardRadius ? `<p><small class="text-warning"><i class="fas fa-exclamation-triangle"></i> Found outside 5km radius</small></p>` : ''}
            <p>${place.vicinity || ''}</p>
            ${place.formatted_phone_number ? `<p><i class="fas fa-phone"></i> ${place.formatted_phone_number}</p>` : ''}
            ${place.website ? `<p><a href="${place.website}" target="_blank">Website</a></p>` : ''}
            <p><small>${place.display_distance || this.formatDistance(place.distance)} from property</small></p>
            <p><small>Search radius: ${Math.round(place.searchRadius / 1000)}km</small></p>
          </div>
        `;

        if (this.infoWindow) {
          this.infoWindow.close();
        }

        this.infoWindow = new google.maps.InfoWindow({ content });
        this.infoWindow.open(this.map, marker);
      });

      this.markers.push(marker);
    },

    getMarkerIcon(serviceType) {
      const iconMap = {
        fire_station: {
          url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
          scaledSize: new google.maps.Size(40, 40),
          anchor: new google.maps.Point(20, 40)
        },
        police: {
          url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
          scaledSize: new google.maps.Size(36, 36),
          anchor: new google.maps.Point(18, 36)
        },
        hospital: {
          url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
          scaledSize: new google.maps.Size(36, 36),
          anchor: new google.maps.Point(18, 36)
        },
        clinic: {
          url: 'https://maps.google.com/mapfiles/ms/icons/ltblue-dot.png',
          scaledSize: new google.maps.Size(34, 34),
          anchor: new google.maps.Point(17, 34)
        },
        school: {
          url: 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
          scaledSize: new google.maps.Size(34, 34),
          anchor: new google.maps.Point(17, 34)
        },
        church: {
          url: 'https://maps.google.com/mapfiles/ms/icons/purple-dot.png',
          scaledSize: new google.maps.Size(34, 34),
          anchor: new google.maps.Point(17, 34)
        },
        gas_station: {
          url: 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png',
          scaledSize: new google.maps.Size(34, 34),
          anchor: new google.maps.Point(17, 34)
        }
      };

      return iconMap[String(serviceType)] || {
        url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
        scaledSize: new google.maps.Size(36, 36),
        anchor: new google.maps.Point(18, 36)
      };
    },

    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371;
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLon = (lon2 - lon1) * Math.PI / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c;

      return distance;
    },

    formatDistance(km) {
      if (km < 0.1) {
        return `${Math.round(km * 1000)}m away`;
      } else if (km < 1) {
        return `${(km * 1000).toFixed(0)}m away`;
      }
      return `${km.toFixed(1)}km away`;
    },

    showDirections(place) {
      if (!place.geometry || !place.geometry.location) return;

      const origin = this.propertyLocation;
      const destination = place.geometry.location;

      const url = `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat()},${destination.lng()}&travelmode=driving`;
      window.open(url, '_blank');
    },

    callPlace(place) {
      if (place.formatted_phone_number) {
        const phoneNumber = place.formatted_phone_number.replace(/[^\d+]/g, '');
        const telUri = `tel:${phoneNumber}`;
        window.location.href = telUri;
      }
    },

    async calculateETAForAllPlaces() {
      const promises = this.nearestPlaces.map(place => {
        return new Promise((resolve) => {
          if (!place.geometry || !place.geometry.location) {
            resolve();
            return;
          }

          const request = {
            origin: this.propertyLocation,
            destination: place.geometry.location,
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.METRIC
          };

          this.directionsService.route(request, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK && result.routes.length > 0) {
              const route = result.routes[0];
              if (route.legs.length > 0) {
                const leg = route.legs[0];
                place.eta = leg.duration.text;
                place.distance_text = leg.distance.text;
                place.distance_meters = leg.distance.value;
                place.duration_seconds = leg.duration.value;
              }
            }
            resolve();
          });
        });
      });

      await Promise.all(promises);
      this.$forceUpdate();
    },

    async calculateETAForShoppingCenters() {
      const promises = this.shoppingCenters.map(center => {
        return new Promise((resolve) => {
          if (!center.geometry || !center.geometry.location) {
            resolve();
            return;
          }

          const request = {
            origin: this.propertyLocation,
            destination: center.geometry.location,
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.METRIC
          };

          this.directionsService.route(request, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK && result.routes.length > 0) {
              const route = result.routes[0];
              if (route.legs.length > 0) {
                const leg = route.legs[0];
                center.eta = leg.duration.text;
                center.distance_text = leg.distance.text;
                center.distance_meters = leg.distance.value;
                center.duration_seconds = leg.duration.value;

                if (leg.distance && leg.distance.value) {
                  const drivingDistanceKm = leg.distance.value / 1000;
                  center.driving_distance = drivingDistanceKm;
                  center.display_distance = this.formatDistance(drivingDistanceKm);
                }
              }
            }
            resolve();
          });
        });
      });

      await Promise.all(promises);
      this.$forceUpdate();
    },

    async toggleDirections(place) {
      const placeKey = place.name;

      if (this.showRoutes[String(placeKey)]) {
        if (this.directionsRenderers[String(placeKey)]) {
          this.directionsRenderers[String(placeKey)].setMap(null);
        }
        this.showRoutes[String(placeKey)] = false;
      } else {
        await this.drawRoute(place);
        this.showRoutes[String(placeKey)] = true;
      }

      this.$forceUpdate();
    },

    async drawRoute(place) {
      if (!place.geometry || !place.geometry.location) return;

      const colorIndex = Object.keys(this.directionsRenderers).length % this.routeColors.length;
      const placeKey = place.name;

      const directionsRenderer = new google.maps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: this.routeColors[String(colorIndex)],
          strokeOpacity: 0.85,
          strokeWeight: 5,
          geodesic: true
        }
      });

      this.directionsRenderers[String(placeKey)] = directionsRenderer;

      try {
        const request = {
          origin: this.propertyLocation,
          destination: place.geometry.location,
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC
        };

        const response = await new Promise((resolve, reject) => {
          this.directionsService.route(request, (result, status) => {
            if (status === google.maps.DirectionsStatus.OK) {
              resolve(result);
            } else {
              reject(new Error(`Directions request failed with status: ${status}`));
            }
          });
        });

        directionsRenderer.setDirections(response);

      } catch (error) {
        if (this.directionsRenderers[String(placeKey)]) {
          this.directionsRenderers[String(placeKey)].setMap(null);
          this.directionsRenderers[String(placeKey)] = undefined;
        }
        this.showRoutes[String(placeKey)] = false;
      }
    },

    resetMapToProperty() {
      if (!this.map || !this.propertyLocation) return;

      this.map.setCenter(this.propertyLocation);
      this.map.setZoom(14);
      this.searchQuery = '';

      if (this.radiusCircle) {
        this.radiusCircle.setCenter(this.propertyLocation);
      }

      this.findNearestServices();
      this.findNearestShoppingCenters();

      if (this.markers.length > 0) {
        this.markers[0].setPosition(this.propertyLocation);
      }
    },

    resetMap() {
      this.resetMapToProperty();
    },

    format_phone_number(phone) {
      if (!phone) return '';
      const cleaned = phone.replace(/\D/g, '');
      if (cleaned.length === 10) {
        return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
      }
      return phone;
    },

    getMapStyle() {
      return [
        {
          "elementType": "geometry",
          "stylers": [{ "color": "#242f3e" }]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [{ "color": "#746855" }]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [{ "color": "#242f3e" }]
        },
        {
          "featureType": "administrative.locality",
          "elementType": "labels.text.fill",
          "stylers": [{ "color": "#d59563" }]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [{ "color": "#d59563" }]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [{ "color": "#263c3f" }]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [{ "color": "#6b9a76" }]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{ "color": "#38414e" }]
        },
        {
          "featureType": "road",
          "elementType": "geometry.stroke",
          "stylers": [{ "color": "#212a37" }]
        },
        {
          "featureType": "road",
          "elementType": "labels.text.fill",
          "stylers": [{ "color": "#9ca5b3" }]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [{ "color": "#746855" }]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [{ "color": "#1f2835" }]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [{ "color": "#f3d19c" }]
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [{ "color": "#2f3948" }]
        },
        {
          "featureType": "transit.station",
          "elementType": "labels.text.fill",
          "stylers": [{ "color": "#d59563" }]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{ "color": "#17263c" }]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [{ "color": "#515c6d" }]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.stroke",
          "stylers": [{ "color": "#17263c" }]
        }
      ];
    },

    isYourOtherProperty(center) {
      if (!center || !center.name) return false;

      const centerName = center.name.toLowerCase();
      let isYourProperty = false;

      // Check all properties in your database
      Object.keys(this.yourPropertyTenants).forEach(propertyName => {
        const propertyNameLower = propertyName.toLowerCase();

        // Check if the center name matches a property name
        if (centerName.includes(propertyNameLower) || propertyNameLower.includes(centerName)) {
          // But make sure it's not the current property
          if (this.selectedProperty && this.selectedProperty.title) {
            const currentPropertyName = this.selectedProperty.title.toLowerCase();
            if (!centerName.includes(currentPropertyName) && !currentPropertyName.includes(centerName)) {
              isYourProperty = true;
            }
          }
        }
      });

      return isYourProperty;
    },
  }
};
